import { render, staticRenderFns } from "./PressReleaseCard.vue?vue&type=template&id=4ba5d5ac"
import script from "./PressReleaseCard.vue?vue&type=script&lang=js"
export * from "./PressReleaseCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CustomDropdown: require('/vercel/path0/components/ui/CustomDropdown.vue').default})
